import media from '@activebrands/core-web/config/media';
import { styled } from '@activebrands/core-web/libs/styletron';

const NotificationWrapper = styled('div', {
    width: 'calc(100vw - 8px)',
    overflow: 'hidden',
    pointerEvents: 'auto',
    backgroundColor: 'var(--color-contrast-lowest)',
    borderRadius: '16px',
    margin: '4px',
    padding: '16px 0',

    [media.min['desktop.sm']]: {
        width: '360px',
        borderRadius: '8px',
        paddingBottom: '8px',
    },
});

export default NotificationWrapper;
